<app-common-bulk-select-performance-employee-dialog
    #selectParticipants
    headerText="{{
        'performance.participants.editParticipantsDialogTitle' | translate: { revieweeName: revieweeName }
    }}"
    label="save"
>
</app-common-bulk-select-performance-employee-dialog>
<ui-card [class.loading]="isLoading">
    <app-segment-header title="performance.participants.editParticipants"></app-segment-header>

    <div class="margin-bottom-2">
        <app-search
            #searchBar
            placeholder="components.dialog-common.searchDots"
            (onSearch)="onSearch($event)"
        ></app-search>
    </div>

    <app-simple-table
        *ngIf="rows?.length"
        [attr.data-cy]="'bulkReviewParticipantsTable'"
        [columns]="columns"
        [rows]="rows"
        [fixedHeight]="true"
        [showInlineButton]="true"
        [inlineButtonText]="'performance.participants.editParticipants'"
        (inlineButtonClicked)="showParticipantsSelectDialog($event)"
        [trackByRow]="trackByRow"
    ></app-simple-table>

    <h3 *ngIf="!rows?.length" class="centered">{{ 'performance.participants.noResults' | translate }}</h3>
</ui-card>
